
import { post, get, getloading, getnolo, postloading, postfileloading, postfile, longtimeoutpostfile, getbolbloading, getmdbolbloading, oldget, oldgetloading, getchartloading, getloadingmap } from '@/utils/request'
import { GOOGLE_MAP_KEY, TD_MAP_KEY, MAPTILER_KEY } from '@/utils/config'

import {
    isDistributorUser,
    isRetailerUser,
    isIndividualUser,
} from "@/utils/localStorageUtils";



// 供应商相关的创建库存 


export const createStockApi = (param) =>
    postloading("/product-serial-number/create-multiple", param, true); //供应商创建库存


// 新版本接口



export const checkDistributorName = (param) =>
    postloading("/open/distributor/register-check", param, false);// 分销商名称检测



export const checkServiceProviderName = (param) =>
    postloading("/open/service-provider/register-check", param, false);// 服务商名称检测



export const checkShopName = (param) =>
    postloading("/open/retailer/register-check", param, false);// 零售商名称检测




export const regularDistributorRegisterApi = (param) =>
    postloading("/open/distributor/register", param, false); //分销商注册


export const regularServiceProviderRegisterApi = (param) =>
    postloading("/open/service-provider/register", param, false); //服务商注册


export const regularShopRegisterApi = (param) =>
    postloading("/open/retailer/register", param, false); //零售商注册



export const regularIndividualUserRegisterApi = (param) =>
    postloading("/open/individual-user/register", param, false); //个人用户注册

export const regularServicePersinelRegisterApi = (param) =>
    postloading("/open/service-personnel/register", param, false); //服务人员注册(游离)


export const regularShopUserRegisterApi = (param) =>
    postloading("/open/retailer-user/register", param, false); //零售人员注册




export const regularDistributorUserRegisterApi = (param) =>
    postloading("/open/distributor-user/register", param, false); //分销商用户注册


export const regularServiceProviderUserRegisterApi = (param) =>
    postloading("/open/service-provider-user/register", param, false); //服务商用户注册



export const regularSupplierUserRegisterApi = (param) =>
    postloading("/open/supplier-user/register", param, false); //供应商用户注册


export const regularDirectVendorUserRegisterApi = (param) =>
    postloading("/open/direct-vendor-user/register", param, false); //直营商用户注册


export const getCurrentUserInfo = (urlparam, param) =>
    getloading(`/user/current?${urlparam}`, param, true); //获取当前用户的信息



export const switchRoleApi = (param) =>
    postloading("/user/switch-login", param, true); //切换角色



// 质保相关

export const productSerialNumberCheckApi = (param) =>
    postloading("/warranty/create/product-serial-number/check", param, true); //产品扫码



export const warrantyConfigQueryDetailApi = (param) =>
    getloading("/warranty-config/query-detail", param, true); //质保配置接口


export const questionnaireQueryDetailApi = (param) =>
    getloading("/questionnaire/query-detail", param, true); //问卷接口



export const questionnaireDetailApi = (param) =>
    getloading("/questionnaire-answer/query-detail", param, true); //问卷详情




export const warrantyDetailApi = (param) =>
    getloading("/warranty/query-detail", param, true); //质保详情







export const questionnaireSubmitApi = (param) =>
    postloading("/questionnaire-answer/submit", param, true); //问卷提交



export const qaFormCreateApi = (param) =>
    postloading("/warranty/create", param, true); //质保创建



// export const qaUserSmsVerificationApi = (param) =>
//     postloading("/warranty/create/user-verification/sms-verification-code/verify", param, true); //质保车主手机号码验证


export const loadIndividualUserApi = (param) =>
    postloading("/warranty/create/load-individual-user", param, true); //加载个人用户信息





export const qaQueryApi = (urlparam, param) => {
    // const encodedUrl = encodeURIComponent(urlparam); // URL 编码地址
    return getloading(`/warranty/query-list?${urlparam}`, param, true); //质保查询
}

// 公开质保查询（免登录，接口路径待后端确认）
export const queryPublicWarrantyListApi = (urlparam, param) =>
    getloading(`/open/warranty/query-list?${urlparam}`, param, false);

// encodeURIComponent




// 质保相关
export const qaUpdateStatusApi = (param) =>
    postloading(`/warranty/update-approval-status`, param, true); //质保审核










export const queryDistributorUserListApi = (urlparam, param) =>
    getloading(`/distributor-user/query-list?${urlparam}`, param, true); //分销商人员列表




export const queryDistributorUserDetailApi = (param) =>
    getloading("/distributor-user/query-detail", param, true); //分销商人员详情




export const queryRetailerUserListApi = (urlparam, param) =>
    getloading(`/retailer-user/query-list?${urlparam}`, param, true); //零售商人员列表



export const queryRetailerUserDetailApi = (param) =>
    getloading("/retailer-user/query-detail", param, true); //零售商人员详情




export const querySupplierUserListApi = (urlparam, param) =>
    getloading(`/supplier-user/query-list?${urlparam}`, param, true); //供应商人员列表


export const queryDirectVendorUserListApi = (urlparam, param) =>
    getloading(`/direct-vendor-user/query-list?${urlparam}`, param, true); //直营商人员列表



export const querySupplierUserDetailApi = (param) =>
    getloading("/supplier-user/query-detail", param, true); //供应商人员详情


export const queryDirectVendorUserDetailApi = (param) =>
    getloading("/direct-vendor-user/query-detail", param, true); //直营商人员详情




export const verifyProductSerialNumber = (param) =>
    postloading("/open/product-serial-number/verify", param, false); //序列号校验



export const authCreate = (param) =>
    postloading("/auth/create", param, false); //序列号校验




// 新版本的采购  


export const getProductCateUrlApi = (levelEqual, fullNameLike, directSuperiorProductCateIdEqual, param) =>
    getloading(`/product-cate/query-list?levelEqual=${levelEqual}&fullNameLike=${fullNameLike[0]}&directSuperiorProductCateIdEqual=${directSuperiorProductCateIdEqual[0]}`, null, true); //SPU分类


export const getProductCateOptionUrlApi = (idEqual, param) =>
    getloading(`/product-cate/query-list?directSuperiorSpuCateIdEqual=${idEqual}`, null, true); //SPU分类



export const getProductApi = (param) =>
    getloading("/product/query-list", param, true); //SPU



export const getProductDetailApi = (param) =>
    getloading("/product/query-detail", param, true); //SPU 详情 也就是SKU列表



// 采购下单相关 新
export const getOrderSpuCateUrlApi = (urlparam, param) => {
    // const encodedUrl = encodeURIComponent(urlparam); // URL 编码地址
    return getloading(`/spu-cate/query-list?${urlparam}`, param, true); //SPU分类
}


export const getOrderProductApi = (param) =>
    getloading("/spu/query-list-by-buyer-party-user", param, true); //SPU列表 


export const getSpuDetailApi = (urlparam, param) =>
    getloading(`/spu/query-detail-by-buyer-party-user?${urlparam}`, param, true); //sku列表

// /sku/query-list



export const getPurchaseSellerOrderQueryLisApi = (urlparam, param) =>
    getloading(`/purchase-order/query-list?${urlparam}`, param, true); //卖家的采购订单列表



export const getPaymentBillListApi = (urlparam, param) =>
    getloading(`/payment/query-list?${urlparam}`, param, true); //付款订单列表



// todo pay 要被替换掉
// export const getPaymentBillBuyerListApi = (urlparam, param) =>
//     getloading(`/payment/query-list-by-buyer-party-user?${urlparam}`, param, true); //付款订单列表(买方)

export const getPaymentBillBuyerListApi = (urlparam, param) =>
    getloading(`/asset-transaction/query-list-by-outcome-asset-party-user?${urlparam}`, param, true); //付款订单列表(买方)

// 付款单列表(收款方 income 视角)
export const getAssetTransactionIncomeListApi = (urlparam, param) =>
    getloading(`/asset-transaction/query-list-by-income-asset-party-user?${urlparam}`, param, true); //付款订单列表(收款方)



export const getQueryProductOrderSummaryApi = (urlparam, param) =>
    getloading(`/purchase-order/query-product-order-summary?${urlparam}`, param, true); //产品订单汇总


export const getBuyerQueryProductOrderSummaryApi = (urlparam, param) =>
    getloading(`/purchase-order/query-product-order-summary-by-buyer-party-user?${urlparam}`, param, true); //买家身份产品订单汇总



// 这个接口要被下面的先跟替代掉
// export const getPaymentMethodQueryLisApi = (urlparam, param) =>
//     getloading(`/payment-method/query-list-by-buyer-party-user?${urlparam}`, param, true); //付款列表

// export const getPaymentMethodQueryLisApi = (urlparam, param) =>
//     getloading(`/asset-account/query-list?${urlparam}`, param, true); //付款列表

export const getPaymentMethodQueryLisApi = (urlparam, param) =>
    getloading(`/asset-account/query-list-by-outcome-asset-party-user?${urlparam}`, param, true); //付款列表





export const getPurchaseSellerOrderDetailApi = (param) =>
    getloading("/purchase-order/query-detail", param, true); //卖家的采购详情



export const getPaymentOrderBillDetailApi = (param) =>
    getloading("/payment/query-detail", param, true); //卖家的付款单详情

// todo pay
// export const getPaymentOrderBillDetailBuyerApi = (param) =>
//     getloading("/payment/query-detail-by-buyer-party-user", param, true); //买家的付款单详情


export const getPaymentOrderBillDetailBuyerApi = (param) =>
    getloading("/asset-transaction/query-detail", param, true); //买家的付款单详情

// 查询资产交易详情（付款单），不带 loading，用于支付宝支付后轮询支付状态
export const getAssetTransactionQueryDetailApi = (param) =>
    getnolo("/asset-transaction/query-detail", param, true);

// 购物车 redis 查询详情（公开接口）：扫码下单时用 content 里的 key 取购物车数据，返回即购物车 JSON
export const getPurchaseOrderCartQueryDetailApi = (param) =>
    getnolo("/open/purchase-order-cart/redis-v20261012-query-detail", param, false);





// 付款方式
export const getPaymentMethodListApi = (urlparam, param) =>
    getloading(`/payment-method/query-list-by-buyer-party-user?${urlparam}`, param, true); //付款方式(由买方用户)



//采购相关


export const getSpuApi = (param) =>
    getloading("/spu/query-list", param, true); //SPU

export const getSpuCateUrlApi = (levelEqual, fullNameLike, param) =>
    getloading(`/spu-cate/query-list?levelEqual=${levelEqual}&fullNameLike=${fullNameLike[0]}`, null, true); //SPU分类

export const getSpuCateOptionUrlApi = (idEqual, param) =>
    getloading(`/spu-cate/query-list?directSuperiorSpuCateIdEqual=${idEqual}`, null, true); //SPU分类


export const getSkuApi = (param) =>
    getloading("/spu/query-detail", param, true); //SPU 详情 也就是SKU列表



export const dealerPurchaseCreateApi = (param) =>
    postloading("/trade-order/create", param, true); //经销商采购单创建












export const couponQueryApi = (urlparam, param) =>
    getloading(`/warranty-coupon/query-list?${urlparam}`, param, true); //优惠券查询


export const couponDetailApi = (param) =>
    getloading(`/warranty-coupon/query-detail`, param, true); //优惠券详情


export const couponRedemptionApi = (param) =>
    postloading("/warranty-coupon/redemption", param, true); //优惠券兑换


export const couponRedemptionCheckApi = (param) =>
    postloading("/warranty-coupon/redemption-check", param, true); //兑换检查



// 库存相关 
// 原来 
// todo kkl 

export const createInBoundApi = (param) =>
    postloading("/warehouse-inventory/batch-inbound", param, true); //创建入库

export const createInBoundTestApi = (param) =>
    postloading("/warehouse-inventory/batch-inbound", param, true); //创建入库

///warehouse-inventory-operation/create-batch-inbound

export const checkStockInApi = (param) =>
    postloading("/warehouse-inventory/batch-inbound-check", param, true); //入库检测

// /warehouse-inventory-operation/create-batch-inbound-check


export const createOutBoundApi = (param) =>
    postloading("/warehouse-inventory/batch-outbound", param, true); //创建出库


///warehouse-inventory-operation/create-batch-outbound

export const checkStockOutApi = (param) =>
    postloading("/warehouse-inventory/batch-outbound-check", param, true); //出库检测


const normalizeOrderOutboundBody = (param = {}) => {
    const listFields = new Set(["productSerialNumberList", "productIdList"]);
    const body = {};

    Object.entries(param).forEach(([key, value]) => {
        if (value == null || value === "") return;

        if (listFields.has(key)) {
            const list = Array.isArray(value) ? value : [value];
            body[key] = list.flat();
            return;
        }

        if (Array.isArray(value)) {
            body[key] = value.length === 1 ? value[0] : value;
            return;
        }

        body[key] = value;
    });

    return body;
};

export const checkStockOrderOutApi = (param) =>
    postloading(
        "/purchase-order/product-outbound-check",
        normalizeOrderOutboundBody(param),
        true
    ); //订单产品出库检测


export const createProductOutBoundApi = (param) =>
    postloading(
        "/purchase-order/product-outbound",
        normalizeOrderOutboundBody(param),
        true
    ); //订单产品出库




// /warehouse-inventory-operation/create-batch-outbound-check


export const getStockDetailApi = (urlparam, param) =>
    getloading(`/warehouse-inventory-detail/query-detail?${urlparam}`, param, true); //查询详情


export const searcOutBoundTargetListApi = (param) =>
    getloading("/warehouse-inventory-outbound-target/query-list", param, true); //查询出库目录列表

// /warehouse-inventory-operation/query-outbound-target-list

// 待入库目录列表
export const searchInBoundTargetListDetailApi = (urlparam, param) =>
    getloading(`/warehouse-inventory-inbound-source/query-detail?${urlparam}`, param, true); //查询入库目录列表详情
// /warehouse-inventory-operation/query-inbound-source-detail

// 待入库
export const geUnInListBaseProductApi = (urlparam, param) =>
    getloading(`/warehouse-inventory-detail/query-product-product-serial-number-grouped-pending-inbound-list?${urlparam}`, param, true); //基于产品-产品序列号的待入库列表
// /warehouse-inventory-operation/query-product-product-serial-number-grouped-pending-inbound-list


// 入库记录
export const getInInventoryGroupedListApi = (urlparam, param) =>
    getloading(`/warehouse-inventory-detail/query-list?${urlparam}`, param, true); //入库记录

// /warehouse-inventory-operation/query-inbound-list


// 待出库
export const searcOutBoundTargetListDetailApi = (urlparam, param) =>
    getloading(`/warehouse-inventory-outbound-target/query-detail?${urlparam}`, param, true); //查询出库目录列表详情

// /warehouse-inventory-operation/query-outbound-target-detail


// 出库记录
export const getOutInventoryGroupedListApi = (urlparam, param) =>
    getloading(`/warehouse-inventory-detail/query-list?${urlparam}`, param, true); //出库记录

// /warehouse-inventory-operation/query-outbound-list

// 库存
export const getInStockListApi = (urlparam, param) =>
    getloading(`/warehouse-inventory-detail/query-product-product-serial-number-grouped-list?${urlparam}`, param, true); //库存中

// /warehouse-inventory-operation/query-product-product-serial-number-grouped-pending-outbound-list


// /warehouse-inventory-detail/query-product-product-serial-number-grouped-pending-inbound-list




export const queryDistributorListApi = (param) =>
    getloading("/distributor/query-inferior-list", param, true); //分销商列表


// /distributor/query-list




export const queryDistributorDetailApi = (param) =>
    getloading("/distributor/query-inferior-detail", param, true); //分销商详情


// /distributor/query-detail


export const queryRetailerListApi = (param) =>
    getloading("/retailer/query-inferior-list", param, true); //零售商列表


// /retailer/query-list



export const queryRetailerDetailApi = (param) =>
    getloading("/retailer/query-inferior-detail", param, true); //零售商详情


// /retailer/query-detail





export const getPurchasePlanQueryLisApi = (urlparam, param) =>
    getloading(`/purchase-plan/query-list-by-buyer-party-user?${urlparam}`, param, true); //买家的采购列表



export const getOrderPurchasePlanQueryLisApi = (urlparam, param) =>
    getloading(`/purchase-order/query-list-by-buyer-party-user?${urlparam}`, param, true); //买家的采购订单列表



export const getBuyerStoreLisApi = (urlparam, param) =>
    getloading(`/shop/query-list-by-buyer-party-user?${urlparam}`, param, true); //买家的店铺列表




export const getSellerStoreLisApi = (urlparam, param) =>
    getloading(`/shop/query-list?${urlparam}`, param, true); //卖家的店铺列表



export const querySellerStoreDetailApi = (param) =>
    getloading("/shop/query-detail", param, true); //分卖家的店铺详情





export const dealerProductPurchaseCreateApi = (param) =>
    postloading("/purchase-plan/create-by-buyer-party-user", param, true); //经销商采购单创建


export const orderProductPurchaseCreateApi = (param) =>
    postloading("/purchase-order/create-multiple-by-buyer-party-user", param, true); //采购订单创建(买方)


export const orderPaymentCreateApi = (param) =>
    postloading("/purchase-order/create-payment-by-buyer-party-user", param, true); //创建付款单(买方)


export const yeepayAggPayPrePayApi = (param) =>
    postloading("/yeepay/aggpay/pre-pay", param, true); //易宝聚合支付预支付


export const paymentUpdateStatusApi = (param) =>
    postloading("/payment/update-status", param, true); //更新状态

// 更新确认状态（资产交易）
export const updateConfirmStatusApi = (param) =>
    postloading("/asset-transaction/update-confirm-status", param, true); //更新确认状态


export const getPurchaseSellerPlanQueryLisApi = (urlparam, param) =>
    getloading(`/purchase-plan/query-list?${urlparam}`, param, true); //卖家的采购列表



export const getDealerProductPurchaseOrderDetailApi = (param) =>
    getloading("/purchase-plan/query-detail", param, true); //采购详情




export const getOrderProductPurchaseOrderDetailApi = (param) =>
    getloading("/purchase-order/query-detail-by-buyer-party-user", param, true); //买家的采购订单详情




export const getDealerProductPurchaseOrderDetailByBuyerApi = (param) =>
    getloading("/purchase-plan/query-detail-by-buyer-party-user", param, true); //采购详情




export const searchInBoundTargetListApi = (param) =>
    getloading("/warehouse-inventory-inbound-source/query-list", param, true); //查询入库目录列表


// /warehouse-inventory-operation/query-inbound-source-list



// 库存相关



























export const warehouseInventoryOperationQueryApi = (urlparam, param) =>
    getloading(`/warehouse-inventory-operation/query-list?${urlparam}`, param, true); //仓库操作列表查询
















// 入库
export const getInventoryGroupedUnInListApi = (urlparam, param) =>
    getloading(`/warehouse-inventory-operation/query-product-warehouse-warehouse-inventory-grouped-pending-inbound-list?${urlparam}`, param, true); //待入库列表















// 入库
















// 新版本接口


export const getCaptchaImg = (param) =>
    getloading("/open/user/sms-login/captcha/create", param, false); //获取图形验证码



export const getDealerCaptchaImg = (param) =>
    getloading("/open/captcha/create", param, false); //获取经销商图形验证码


export const sendSmsApi = (param) =>
    postloading("/open/user/sms-login/sms-verification-code/send", param, false); //获取短信验证码


export const sendDealerSmsApi = (param) =>
    postloading("/open/sms-verification-code/send", param, false); //获取经销商短信验证码


export const smsVerifyApi = (param) =>
    postloading("/open/user/sms-login/sms-verification-code/verify", param, false); //短信验证登录



export const smsLoginApi = (param) =>
    postloading("/open/user/sms-login", param, false); //短信验证登录



export const regularUserRegisterApi = (param) =>
    postloading("/open/cfilm-user/sms-register/regular-user", param, false); //常规用户-短信注册



export const regularDealerUserRegisterApi = (param) =>
    postloading("/open/cfilm-user/sms-register/dealer-user", param, false); //经销商用户-短信注册


export const regularDealerRegisterApi = (param) =>
    postloading("/open/dealer-apply/create", param, false); //经销商-短信注册



export const regularDealerRegisterWithTokenApi = (param) =>
    postloading("/dealer-apply/create", param, true); //经销商-短信注册






export const getDealerListWithTokenApi = (param) =>
    getloading(`/dealer/query/list`, param, true); //获取经销商列表






export const getProductWithNoApi = (param) =>
    getloading("/cfilm-product-instance/query/detail/by-serial-number", param, true); //根据卷芯号获取产品信息




export const getProductWithNoNoTokenApi = (param) =>
    getloading("/open/cfilm-product-instance/query/detail/by-serial-number", param, false); //根据卷芯号获取产品信息






export const uploadImgApi = (param) =>
    postfileloading("/open/pic-file/upload", param, false); //图片上传


export const uploadImgNoLoadingApi = (param) =>
    postfile("/open/pic-file/upload", param, false); //图片上传

export const uploadImgNoLoadingLongTimeOutApi = (param) =>
    longtimeoutpostfile("/open/pic-file/upload", param, false); //图片上传





export const createQaApi = (param) =>
    postloading("/open/cfilm-ewc/create", param, false); //创建质保



export const getQaInfoWithSmsApi = (param) =>
    getloading("/open/cfilm-ewc/query/list", param, false); //根据短信获取质保信息

export const getQaInfoWithRegulerUserApi = (param) =>
    getloading("/cfilm-ewc/regular-user/query/list", param, true); //常规用户获取质保信息

export const getQaInfoWithDealerApi = (param) =>
    getloading("/cfilm-ewc/dealer-user/query/list", param, true); //经销商查看自己和自己名下经销商的质保信息

export const getQaInfoWithDealerWithUrlParamApi = (urlparam, param) =>
    getloading(`/cfilm-ewc/dealer-user/query/list?${urlparam}`, param, true); //经销商查看自己和自己名下经销商的质保信息



// export const getProductInfoApi = (param) =>
//     getloading("/cfilm-product-instance/query/detail/by-serial-number", param, true); //获取产品的信息


export const confirmQaApi = (param) =>
    postloading("/cfilm-ewc/confirm", param, true); //质保确认

export const rejectQaApi = (param) =>
    postloading("/cfilm-ewc/reject", param, true); //质保驳回



export const getSpuCateApi = (param) =>
    getloading("/spu-cate/query/list", param, true); //SPU分类

















export const operateStockInApi = (param) =>
    postloading("/cfilm-product-instance/operate-in/by-serial-number", param, true); //操作入库



export const operateStockOutApi = (param) =>
    postloading("/cfilm-product-instance/operate-out/by-serial-number", param, true); //操作出库



export const getStockListApi = (param) =>
    getloading("/cfilm-product-instance/query/list", param, true); //库存列表









export const getDealerPurchaseOrderApi = (param) =>
    getloading("/dealer-purchase/query/list", param, true); //采购列表



export const getDealerPurchaseOrderForSuperiorDealerApi = (param) =>
    getloading("/dealer-purchase/query/list/for-superior-dealer", param, true); //经销商的采购列表


export const getDealerPurchaseOrderDetailApi = (param) =>
    getloading("/dealer-purchase/query/detail", param, true); //采购详情



export const getStockApi = (param) =>
    getloading("/dealer-purchase/query/list", param, true); //库存列表






// 获取国家
export const getCountryApi = (param) =>
    getloading("/open/country/query-list", param, false)

// 获取省份
export const getProvinceApi = (param) =>
    getloading("/open/province/query-list", param, false)

// 获取城市
export const getCityApi = (param) =>
    getloading("/open/city/query-list", param, false)


export const getCityListApi = (urlparam, param) =>
    getloading(`/open/city/query-list?${urlparam}`, param, false); //查询地址列表


// 获取区县
export const getDistrictApi = (param) =>
    getloading("/open/district/query-list", param, false)



export const geBoldApi = (url) =>
    getbolbloading(url, {}, false)


export const geMdBoldApi = (url) =>
    getmdbolbloading(url, {}, false)


//地址相关 
export const createAddressApi = (param) =>
    postloading("/address/create", param, true); //地址创建



export const getAddressListApi = (urlparam, param) =>
    getloading(`/address/query-list?${urlparam}`, param, true); //查询地址列表



export const getAddressDetailApi = (urlparam, param) =>
    getloading(`/address/query-detail?${urlparam}`, param, true); //查询地址详情




// 零售商查商列表
export const getOpenRetailerListApi = (urlparam, param) =>
    getloading(`/open/retailer/query-list?${urlparam}`, param, false); //查零售商商列表

export const getOpenRetailerListApiSilent = (urlparam, param) =>
    get(`/open/retailer/query-list?${urlparam}`, param, false);

// 获取区县
export const getMultiLevelDistrictApi = (urlparam, param) =>
    getloading(`/open/district/query-list?${urlparam}`, param, false)

export const getMultiLevelDistrictApiSilent = (urlparam, param) =>
    get(`/open/district/query-list?${urlparam}`, param, false)



// 仓库相关
export const createWareHouseApi = (param) =>
    postloading("/warehouse/create", param, true); //仓库创建

export const getWareHouseListApi = (urlparam, param) =>
    getloading(`/warehouse/query-list?${urlparam}`, param, true); //查询仓库列表

export const getWareHouseDetailApi = (urlparam, param) =>
    getloading(`/warehouse/query-detail?${urlparam}`, param, true); //查询仓库详情










//     API 限制：

//     免费用户每天的 API 调用次数有限，查看 Google Maps Platform 使用限制。

// 错误处理：

//     如果 API 返回状态为 OVER_QUERY_LIMIT 或 REQUEST_DENIED，需要检查密钥配置和配额。

// 编码地址：

//     确保使用 encodeURIComponent 对地址进行 URL 编码，避免特殊字符导致错误。
// 获取谷歌地址解析
export const getGoogleMapLocation = (address) => {
    const encodedAddress = encodeURIComponent(address); // URL 编码地址
    return getloadingmap(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${GOOGLE_MAP_KEY}`, {}, false); //获取谷歌地址解析
}









// 天地图地址解析（使用完整 URL，不走 baseURL）
export const getTdMapLocation = (address) => {
    // const encodedAddress = encodeURIComponent(address); // URL 编码地址
    let encodedAddress = JSON.stringify({
        keyWord: address
    })
    return getloadingmap(`https://api.tianditu.gov.cn/geocoder?ds=${encodedAddress}&tk=${TD_MAP_KEY}`, {}, false);
}


// MapTiler 正向地理编码
export const getMapTilerGeocode = (address, language = 'zh') => {
    const encodedAddress = encodeURIComponent(address);
    return getloadingmap(
        `https://t/geocoding/${encodedAddress}.json?key=${MAPTILER_KEY}&language=${language}`,
        {},
        false
    );
};

// MapTiler 逆地理编码
export const getMapTilerReverseGeocode = ({ lng, lat, language = 'zh' }) => {
    return getloadingmap(
        `https://api.maptiler.com/geocoding/${lng},${lat}.json?key=${MAPTILER_KEY}&language=${language}`,
        {},
        false
    );
};

// 天地图根据经纬度 获取城市（使用完整 URL，不走 baseURL）
export const getTdMapLocationCityName = ({ lng, lat }) => {
    // const encodedAddress = encodeURIComponent(address); // URL 编码地址
    const postStr = JSON.stringify({
        lon: lng,
        lat: lat,
        ver: 1
    });
    return getloadingmap(`https://api.tianditu.gov.cn/geocoder?postStr=${postStr}&type=geocode&tk=${TD_MAP_KEY}`, {}, false);
}


// 获取 dataease 的 token
export const getDEToken = (useName) => {
    return getchartloading(`https://mb.dev.youbanban.com/plutus/api/token?userName=${useName}`, {}, false); //获取 dataease 的 token
}


// 还保留的 



export const getTieLeYaListApi = (param) =>
    oldget("/public/cfilm-tieleya-paint-design/query/list", param, false); //获取彩绘列表


export const getTieLeYaListDetailApi = (param) =>
    oldgetloading("/public/cfilm-tieleya-paint-design/query/detail", param, false); //获取彩绘详情




export const getDealerListApi = (param) =>
    oldgetloading(`/public/dealer/query/list`, param, false); //获取经销商列表

